import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import {
  StyledButtonContainer,
  ModalContent,
  ModalOverlay,
  ModalCard,
  ModalHeader,
  ModalActions,
} from './ConfirmationModal.styles';
import { Button } from '@mui/material';

const ConfirmationModal = ({ open, onConfirm, onClose, title, confirmButtonText, cancelButtonText = 'Cancel' }) => {
  const handleConfirmClick = () => {
    onConfirm();
    onClose();
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <ModalOverlay
          as={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleBackdropClick}
        >
          <ModalCard>
            <ModalContent>
              <ModalHeader>
                {typeof title === 'string' ? (
                  <Typography variant="h6" component="h2">
                    {title}
                  </Typography>
                ) : (
                  title
                )}
              </ModalHeader>
              <ModalActions>
                <StyledButtonContainer>
                  <Button fullWidth variant="primaryDestructive" onClick={onClose}>
                    {cancelButtonText}
                  </Button>
                  <Button fullWidth variant="primary" onClick={handleConfirmClick}>
                    {confirmButtonText}
                  </Button>
                </StyledButtonContainer>
              </ModalActions>
            </ModalContent>
          </ModalCard>
        </ModalOverlay>
      )}
    </AnimatePresence>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string,
};

export default ConfirmationModal;
